// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Op-z","imageAndVideoCount":"Pp-z","imageAndVideoContainer":"Qp-z","viewAllReviews":"Rp-z"};